module.exports = __webpack_public_path__ + "fonts/3c5ebd87cbd775f3be8ed0551a682ef8.ttf";